import React from "react";
import styled from "styled-components";
import { Preloader } from "@icg360/ui-toolkit";

const Page = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;

export default () => (
  <Page data-bdd="loading-page">
    <Preloader />
  </Page>
);
